

module.exports = (hex) => {
  let matches = /^([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/.exec(hex);
  return matches ? matches[1] + matches[1] + matches[2] + matches[2] + matches[3] + matches[3] : hex;
};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/expand.js